var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("channel",function(){return [_c('span',{style:({ color: _vm.channelColor })},[(_vm.selectedChannel.icon)?_c('em',{class:_vm.selectedChannel.icon}):_vm._e(),_vm._v(" "+_vm._s(_vm.selectedChannel.text)+"\n    ")])]},null,{ selectedChannel: _vm.selectedChannel, channelColor: _vm.channelColor })],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4aaba476","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/ChannelLabel.vue
// module id = null
// module chunks = 